import * as  common from '@/service/common';
import * as  order from '@/service/order';
import * as  shmeeting from '@/service/shmeeting';
import * as  vipmeeting from '@/service/vipmeeting';
export default {
	...common,
	...order,
	...shmeeting,
	...vipmeeting,
}
